import { RequestType } from '../model/enums/RequestType';
import { PublicAccessInfoDtoFormTypeEnum } from '../generated';

export const parseRequestType = (data: PublicAccessInfoDtoFormTypeEnum): RequestType => {
  switch (data) {
    case PublicAccessInfoDtoFormTypeEnum.DoctorRegistration:
      return RequestType.DoctorRegistration;
    case PublicAccessInfoDtoFormTypeEnum.PatientRegistration:
      return RequestType.PatientRegistration;
    case PublicAccessInfoDtoFormTypeEnum.ReceiptOrder:
      return RequestType.ReceiptOrder;
  }
};
